import { TFunction } from 'i18next'
import { Route } from '../../config/router'

export const getLinkText = (backTo: Route, t: TFunction): string => {
  switch (backTo) {
    case Route.ADD_MOBILE:
      return t('common:page.add-mobile', { context: 'back' })
    case Route.ADD_PAYMENT_METHOD:
      return t('common:page.add-payment-method', { context: 'back' })
    case Route.CREATE_PASSWORD:
      return t('common:page.create-password', { context: 'back' })
    case Route.ENTER_EMAIL:
      return t('common:page.login', { context: 'back' })
    case Route.ENTER_PASSWORD:
      return t('common:page.password', { context: 'back' })
    case Route.NEW_PAYMENT_METHOD:
      return t('common:page.new-payment-method', { context: 'back' })
    case Route.NEW_SHIPPING_ADDRESS:
      return t('common:page.new-shipping-address', { context: 'back' })
    case Route.ONE_TIME_PASSWORD:
      return t('common:page.login-one-time-code', { context: 'back' })
    case Route.PAY:
      return t('common:page.processing', { context: 'back' })
    case Route.PAYMENT_METHOD:
      return t('common:page.payment-method', { context: 'back' })
    case Route.SHIPPING_ADDRESS:
      return t('common:page.shipping-address', { context: 'back' })
    case Route.SIGN_UP:
      return t('common:page.sign-up', { context: 'back' })
    case Route.SUMMARY:
      return t('common:page.summary', { context: 'back' })
    case Route.TERMINAL_ERROR:
      return t('common:page.oh-no', { context: 'back' })
    case Route.AMOUNT_TOO_HIGH:
      return t('common:page.oh-no-amount_too_high', { context: 'back' })
    case Route.ORDER_LIMIT_EXCEEDED:
      return t('common:page.oh-no-max_active_orders_reached', { context: 'back' })
    case Route.OVERDUE_PAYMENTS_CHECKOUT_PAYMENT_ELIGIBLE:
      return t('common:page.oh-no-overdue_payments_checkout_payment_eligible', { context: 'back' })
    case Route.VERIFY:
      return t('common:page.verify', { context: 'back' })
    case Route.VERIFY_CHALLENGE:
      return t('common:page.verify-challenge', { context: 'back' })
    case Route.VERIFY_IDENTITY:
      return t('common:page.verify-identity', { context: 'back' })
    case Route.VERIFY_LICENCE:
      return t('common:page.verify-identity-licence', { context: 'back' })
    case Route.VERIFY_MEDICARE:
      return t('common:page.verify-identity-medicare', { context: 'back' })
    case Route.VERIFY_PASSPORT:
      return t('common:page.verify-identity-passport', { context: 'back' })
    case Route.VERIFY_RETRY:
      return t('common:page.verify-retry', { context: 'back' })
    case Route.KYC_CONFIRM_DETAILS:
      return t('common:page.verify-confirm-details', { context: 'back' })
    case Route.GET_STARTED:
      return t('common:page.onboarding-get-started', { context: 'back' })
    default:
      return ''
  }
}
